import api from './api'
import { Subscription, PlanKey, PlanInfo, PlanInfoAdmin } from '../types/billingTypes'

// ── Public (authenticated) ──────────────────────────────────────

export const getSubscription = async (): Promise<Subscription> => {
  const response = await api.get<Subscription>('/billing/subscription/')
  return response.data
}

export const getPlans = async (): Promise<PlanInfo[]> => {
  const response = await api.get<PlanInfo[]>('/billing/plans/')
  return response.data
}

export interface CheckoutResult {
  upgraded: boolean
  url?: string
  subscription?: Subscription
}

export const createCheckoutSession = async (plan: PlanKey): Promise<CheckoutResult> => {
  const response = await api.post<{ upgraded?: boolean; url?: string; subscription?: Subscription }>('/billing/checkout-session/', { plan })
  if (response.data.upgraded) {
    return { upgraded: true, subscription: response.data.subscription }
  }
  return { upgraded: false, url: response.data.url }
}

export const createPortalSession = async (): Promise<string> => {
  const response = await api.post<{ url: string }>('/billing/portal-session/', {})
  return response.data.url
}

// ── Super admin ─────────────────────────────────────────────────

export const getAdminPlans = async (): Promise<PlanInfoAdmin[]> => {
  const response = await api.get<PlanInfoAdmin[]>('/billing/admin/plans/')
  return response.data
}

export const createAdminPlan = async (data: Partial<PlanInfoAdmin>): Promise<PlanInfoAdmin> => {
  const response = await api.post<PlanInfoAdmin>('/billing/admin/plans/', data)
  return response.data
}

export const updateAdminPlan = async (id: string, data: Partial<PlanInfoAdmin>): Promise<PlanInfoAdmin> => {
  const response = await api.patch<PlanInfoAdmin>(`/billing/admin/plans/${id}/`, data)
  return response.data
}

export const deleteAdminPlan = async (id: string): Promise<void> => {
  await api.delete(`/billing/admin/plans/${id}/`)
}

export const getOrgSubscription = async (orgId: string): Promise<Subscription> => {
  const response = await api.get<Subscription>(`/billing/admin/orgs/${orgId}/subscription/`)
  return response.data
}

export const updateOrgSubscription = async (
  orgId: string,
  data: { plan: string; seats?: number },
): Promise<Subscription> => {
  const response = await api.patch<Subscription>(`/billing/admin/orgs/${orgId}/subscription/`, data)
  return response.data
}
